import { Accordion, TDeviceType } from '@cian/ui-kit';
import { QUESTIONS_FOR_SALES_AND_RENTS } from 'shared/constants/questions/questionsSalesAndRents';
import * as styles from './styles.css';
import { Question } from './Question/Question';
import { EDealType } from 'shared/types/wantType';
import { QUESTIONS_FOR_HOSTS } from 'shared/constants/questions/questionsHosts';

interface IQuestionsProps {
  onOtherLinks: (link: string, title: string, id: number) => void;
  device: TDeviceType;
  dealType: EDealType;
}

export const Questions: React.FC<IQuestionsProps> = ({ onOtherLinks, device, dealType }) => {
  const LIST = dealType === EDealType.Host ? QUESTIONS_FOR_HOSTS : QUESTIONS_FOR_SALES_AND_RENTS;

  return (
    <div className={styles['container']}>
      <div className={styles['title']}>{device === 'phone' ? 'Вопросы' : 'Ответы на вопросы'}</div>
      <Accordion
        size={device === 'phone' ? 'S' : 'M'}
        items={LIST.map(item => ({
          title: item.question,
          content: item.answer.map((row, key) => (
            <Question
              needDot={item.answer.length - 1 === key}
              questionId={item.id}
              questionTitle={item.question}
              key={key}
              row={row}
              onOtherLinks={onOtherLinks}
            />
          )),
        }))}
      />
    </div>
  );
};
